const ru = {
    nav: { //头部导航
        navList: [{
                name: "Главная страница",
                url: "/",
            },
            {
                name: "О нас",
                url: "/about",
            },
            {
                name: "Основные направления деятельности",
                url: "/gpc",
            },
            {
                name: "Сферы деятельности",
                url: "/besinessScope/bulkTrade",
            },
            {
                name: "Центр новостей",
                url: "/news",
            },
            {
                name: "Cоциальная ответственность",
                url: "/socialResponsibility",
            },
            {
                name: "Pазвитие талантов",
                url: "/talentDevelopment",
            },
            {
                name: "Hадзор и отчетность",
                url: "/supervisionAndReporting",
            },
        ],
        Logo: require("../../assets/img/base/logo20.png"),
        Logo_white: require("../../assets/img/base/logo20_white.png"),
        Language: {
            cn: "中文",
            en: "ENGLISH",
            ru: "РУССКИЙ"
        },
    },
    foot: { //脚注和全屏菜單
        footNav: [{
                title: {
                    name: "O нас",
                    url: "/about",
                },
                list: [{
                        name: "Краткая информация о компании",
                        url: "/about",
                        param: "company"
                    },
                    {
                        name: "История развития",
                        url: "/about",
                        param: "history"
                    },
                    {
                        name: "Kорпоративная культура",
                        url: "/about",
                        param: "culture"
                    },
                    {
                        name: "Достижения  компании",
                        url: "/about",
                        param: "honor"
                    },
                    {
                        name: "Cтиль работы команды",
                        url: "/about",
                        param: "teamStyle"
                    },
                ]
            },
            {
                title: {
                    name: "Основные направления деятельности",
                    url: "/gpc",
                },
                list: [{
                        name: "Нефтяной кокс",
                        url: "/gpc",
                        param: ""
                    },
                    {
                        name: "Прокаленный кокс",
                        url: "/cpc",
                        param: ""
                    },
                ]
            },
            {
                title: {
                    name: "Сферы деятельности",
                    url: "/besinessScope/bulkTrade",
                },
                list: [{
                        name: "Oптовая торговля",
                        url: "/besinessScope/bulkTrade",
                        param: ""
                    },
                    {
                        name: "Комплексная логистика",
                        url: "/besinessScope/integratedLogistics",
                        param: ""
                    },
                    {
                        name: "Производство",
                        url: "/besinessScope/productionManufacturing",
                        param: ""
                    },
                    {
                        name: "Kоординация промышленности и финансов",
                        url: "/besinessScope/industryFinanceCollaboration",
                        param: ""
                    },
                    {
                        name: "Кадровое обеспечение",
                        url: "/besinessScope/exportOfServices",
                        param: ""
                    },
                ]
            },
            {
                title: {
                    name: "Центр новостей",
                    url: "/news",
                },
                list: [{
                        name: "Последние новости",
                        url: "/news",
                        param: "tab1"
                    },
                    {
                        name: "Cообщения в СМИ",
                        url: "/news",
                        param: "tab2"
                    },
                    {
                        name: "Презентация компании",
                        url: "/news",
                        param: "tab3"
                    },
                ]
            },
            {
                title: {
                    name: "Социальная ответственность",
                    url: "/socialResponsibility",
                },
                list: [{
                        name: "Защита окружающей среды",
                        url: "/socialResponsibility",
                        param: "environmental"
                    },
                    {
                        name: "Hаучно-технические инновации",
                        url: "/socialResponsibility",
                        param: "science"
                    },
                    {
                        name: "Cоциальное обеспечение",
                        url: "/socialResponsibility",
                        param: "socialGood"
                    },
                ]
            },
            {
                title: {
                    name: "Pазвитие талантов",
                    url: "/talentDevelopment",
                },
                list: [{
                        name: "Pазвитие талантов",
                        url: "/talentDevelopment",
                        param: ""
                    },
                    {
                        name: "Вакансии",
                        url: "/talentRecruitment/1",
                        param: ""
                    },
                ]
            },
            {
                title: {
                    name: "Hадзор и отчетность",
                    url: "/supervisionAndReporting",
                },
                list: [{
                    name: "Hадзор и отчетность",
                    url: "/supervisionAndReporting",
                    param: ""
                }]
            },
        ],
        Address: "Адрес штаб-квартиры:13-й этаж, здание China Minmetals, № 15, Четвертый район Аньхуйли, район Чаоян, Пекин",
        Phone: "Тел:  +86 10-84831159   Внутренняя торговля: +86 10-84833454   Внешняя торговля: +86 10-84832433",
        tel:"По вопросам сотрудничества: +86 17813617961 &nbsp;&nbsp; Приёмная руководителя: +86 17813617885",
        Email: "Почтовый ящик：Gaoxin@gaoxincarbon.com",
        RecruitTel: "Телефон для соискателей: 17813617991",
        RecruitEmail: "Почта для резюме: hr@dqc.group",
        contactUs: "Подписывайтесь к нам",
        copyright: "DQ CARBON GROUP",
    },
    sidebar: {
        Message: "Оставьте сообщение",
    },
    dialogContact: { //联系我们弹框
        TelephoneCounseling: "电话咨询",
        DomesticTradePhone: "内贸",
        ForeignTradePhone: "外贸",
        HRphone: "总机"
    },
    messageBoard: { //在线留言弹框
        OnlineMessage: "Оставьте сообщение",
        BusinessType: "Вид бизнеса",
        SelectBusinessType: "Выберите вид бизнеса",
        name: "имя",
        phone: "телефон",
        email: "почтовый ящик",
        message: "сообщение",
        SubmitMessage: "Отправить",
        rules: {
            SelectBusinessType: "Выберите вид бизнеса",
            EnterName: "Пожалуйста, введите ваше имя и фамилию",
            NameLength: "Длина от 2 до 20 символов",
            ContactNumber: "Введите контактный номер телефона",
            PhoneLength: "Пожалуйста, введите правильный номер мобильного телефона",
            EmailAddress: "Пожалуйста, введите адрес электронной почты",
            CorrectEmailAddress: "Пожалуйста, введите правильный адрес электронной почты",
            messageContent: "Пожалуйста, введите сообщение",
        },
        SubmitSuccessfully: "Отправить успешна"
    },
    home: {
        banner: {
            businessScope: [{
                    title: "Оптовая торговля",
                    icon: require("../../assets/img/home/trade.png"),
                    des: "Комплексное обслуживание основного бизнеса группы",
                    businessSlide: `<li>Энергетика</li>
                        <li>Промышленное сырье</li>
                        <li>Металлы / минералы</li>
                        <li>Нефтехимическая продукция</li>
                        <li>Сельскохозяйственная продукция</li>
                        <li>Электромеханические приборы</li>
                        <li>Литиевые батареи и вспомогательные продукты.</li>`,
                    pic: require("../../assets/img/base/trade.png"),
                    src: '/besinessScope/bulkTrade'
                },
                {
                    title: "Интегрированная логистика",
                    icon: require("../../assets/img/home/logistics.png"),
                    des: "Расположение глобальной логистической сети",
                    businessSlide: `<li>Складирование и логистика</li>
                        <li>Через границу</li>
                        <li>Сетевые грузоперевозки</li>`,
                    pic: require("../../assets/img/base/logistics.png"),
                    src: '/besinessScope/integratedLogistics'
                },
                {
                    title: "Производство",
                    icon: require("../../assets/img/home/manufacturing.png"),
                    des: "Модернизация производственной цепочки",
                    businessSlide: `<li>Завод Лунтэн в Фушуне</li>
                        <li>Завод по переработке алюминиевых изделий</li>`,
                    pic: require("../../assets/img/base/manufacturing.png"),
                    src: '/besinessScope/productionManufacturing'
                },
                {
                    title: "Координация промышленности и финансов",
                    icon: require("../../assets/img/home/finance.png"),
                    des: "Повышение стоимости активов",
                    businessSlide: `<li>Глобальное размещение</li>
                        <li>Закупки и маркетинг</li>
                        <li>Гарантия и факторинг</li>
                        <li>Инвестиции в промышленность</li>`,
                    pic: require("../../assets/img/base/finance.png"),
                    src: '/besinessScope/industryFinanceCollaboration'
                },
                {
                    title: "Кадровое обеспечение",
                    icon: require("../../assets/img/home/services.png"),
                    des: "Kадровые ресурсы",
                    businessSlide: `<li>Корпоративное преимущество</li>`,
                    pic: require("../../assets/img/base/services.png"),
                    src: '/besinessScope/exportOfServices'
                }
            ],
            year20: "Специальный репортаж о 20-летии"
        },
        company: {
            headlineTitle: "Введение в бизнес",
            headlineP: "COMPANY INTRODUCTION",
            map: {
                Canada: "Канада",
                USA: "США",
                Colombia: "Колумбия",
                Brazil: "Бразилия",
                Chile: "Чили",
                Argentina: "Аргентина",
                Germany: "Германия",
                Romania: "Румыния",
                Turkey: "Турция",
                Egypt: "Египет",
                Saudi_Arabia: "Саудовская Аравия",
                Kazakhstan: "Казахстан",
                Turkmenistan: "Туркменистан",
                Dubai: "Дубай",
                India: "Индия",
                Russia: "Россия",
                China: "Китай",
                Taiwan: "Тайвань, Китай ",
                Malaysia: "Малайзия",
                Korea: "Корея",
                Japan: "Япония",
                Philippines: "Филиппины",
                Indonesia: "Индонезия",
                Sydney: "Сидней"
            },
            companyName: "DQ CARBON GROUP",
            nameTag: "DQ CARBON GROUP",
            companyNumber: [{
                    detail: "Создание предприятия"
                },
                {
                    detail: "Филиалы в Китае и за рубежом"
                },
                {
                    detail: "Бизнес по всей стране"
                },
                {
                    detail: "Корпоративные сотрудники"
                },
            ],
            more: "Больше"
        },
        businessLayout: {
            headlineTitle: "Деловая планировка",
            headlineP: "BUSINESS LAYOUT",
        },
        product: {
            headlineTitle: "Основной продукт",
            headlineP: "MAIN PRODUCT",
            res: [{
                    title: "Нефтяной кокс",
                    titleEn: "GPC",
                    des: `Компания в основном сотрудничает с нефтеперерабатывающими заводами, принадлежащими Sinopec, Petro-China, CNPC, нефтеперерабатывающими заводами в провинции Шаньдун, на Северо-востоке, Северо-западе, в провинции Хэнань, Хэбэй, Цзянсу и других местах, крупными иностранными нефтехимическими компаниями и трейдерами, а также установила долгосрочные стратегические партнерские отношения с крупными отечественными и зарубежными алюминиевыми заводами, сталелитейными заводами, заводами по производству металлического кремния. заводы, предприятия по производству стекла и т.д.`,
                    pic: require("../../assets/img/home/gpc.png"),
                    src: "/gpc"
                },
                {
                    title: "Прокаленный кокс",
                    titleEn: "CPC",
                    des: `В 2018 году наша компания открыла завод по переработке кальцинированного кокса в Хулудао, провинция Ляонин. Мощность введенного в эксплуатацию завода может достигать 200 000 тонн кальцинированного кокса и 6000 тонн в месяц с низким содержанием серы для производства графитированных электродов. В компании работают специалисты по переработке обожженного кокса и профессиональная техническая команда, в основном для компании Jinxi Daqing Fushun, которая занимается производством прокаливания и сортировки нефтяного кокса, которые могут быть настроены в соответствии с потребностями клиентов, а качество предоставляемых услуг по переработке гарантировано. С точки зрения качества и цены продукции, логистики и складского контроля продукции, а также быстрого расчета, мы можем оптимизировать план закупок для наших клиентов, чтобы гарантировать высокое качество продукции, разумную цену и своевременную доставку. Сократите расходы для наших клиентов, обеспечьте качественный сервис и увеличьте ценность.`,
                    pic: require("../../assets/img/home/cpc.png"),
                    src: "/cpc"
                },
            ],
            button: "Узнать больше"
        },
        news: {
            headlineTitle: "Новости.",
            headlineP: "NEWS INFORMATION",
        },
        partner: {
            headlineTitle: "Компании-партнёры",
            headlineP: "COOPERATIVE ENTERPRISE",

        }
    },
    about: {
        banner: {
            bannerTitle: "о нас",
            bannerP: "Базироваться на ресурсах - Создавать Ценность",
        },
        company: {
            headlineTitle: "Краткое описание корпорации",
            headlineP: "Group Profile",
        },
        messageFromChairman: {
            title: "Послание председателя правления группы",
        },
        history: {
            headlineTitle: "История развития",
            headlineP: "DEVELOPMENT HISTORY",
        },
        culture: {
            headlineTitle: "Корпоративная культура",
            headlineP: "CORPORATE CULTURE",
            section: [{
                    title: "Концепция развития",
                    des: `<p>Управление предприятиями в соответствии с законом и моральными принципами</p><p>Управлять предприятием усердно и бережливо, любить предприятие искренне</p><p>Укрепление предприятия с помощью талантов, развитие предприятия с помощью науки и техники</p>`
                },
                {
                    title: "Взгляд на рынок",
                    des: `<p>Обеспечить хорошое  качество и создать выдающийся бренд </p><p>Успех наших клиентов - это наш успех</p><p>Ценность наших клиентов-это и наша ценность</p>`
                },
                {
                    title: " Кадровая философия",
                    des: `<p>Основываться на знаниях ориентироваться на человека</p><p>Уважать и ценить таланты</p><p>Развививать и привлекать таланты</p>`
                },
                {
                    title: "Представление об эффективности",
                    des: `<p>На шаг быстрее, весь путь впереди</p>`
                },
                {
                    title: "Филсофия конкуренции",
                    des: `<p>Великие начинания достигаются упорным трудом</p>`
                },
                {
                    title: "Взгляд на рост",
                    des: `<p>Самодисциплина для  убеждения других, щедрое отношение к другим.</p><p>Небольшого достатка достаточно, чтобы собрать людей вместе,  но ведет людей тот, кто подает пример.</p>`
                }
            ]
        },
        honor: {
            headlineTitle: "Награды",
            headlineP: "Honors & Awards",
        },
        teamStyle: {
            headlineTitle: "Наша команда",
            headlineP: "Team Highlights",
        }
    },
    mainBusiness: {
        gpc: {
            header: {
                typeTitle: "Основной продукт",
                title: "Нефтяной кокс",
                enTitle: "GPC",
                des: `Компания в основном сотрудничает с нефтеперерабатывающими заводами, принадлежащими Sinopec, Petro-China, CNPC, нефтеперерабатывающими заводами в провинции Шаньдун, на Северо-востоке, Северо-западе, в провинции Хэнань, Хэбэй, Цзянсу и других местах, крупными иностранными нефтехимическими компаниями и трейдерами, а также установила долгосрочные стратегические партнерские отношения с крупными отечественными и зарубежными алюминиевыми заводами, сталелитейными заводами, заводами по производству металлического кремния. заводы, предприятия по производству стекла и т.д.`,
            },
            parameters: {
                title: "Общепринятое значение",
                tabs: {
                    internal: "Отечественные",
                    foreign: "Зарубежные",
                },
                parameterRow: [{
                        pic: require("../../assets/img/mainBusiness/sy.png"),
                        lists: [{
                                value: "＜0.5",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "＜10",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "＜0.35",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜10",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "＜100",
                                name: "Содержание железа(%)"
                            },
                            {
                                value: "＜200",
                                name: "Содержание кремния(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/sh.png"),
                        lists: [{
                                value: "＜2.2",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "＜0.5",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "＜10",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜150",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "＜100",
                                name: "Содержание железа(%)"
                            },
                            {
                                value: "＜200",
                                name: "Содержание кремния(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/nooc.png"),
                        lists: [{
                                value: "＜0.5",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "＜10",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜0",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "＜250",
                                name: "Содержание железа(%)"
                            },
                            {
                                value: "＜200",
                                name: "Содержание кремния(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/dl.png"),
                        lists: [{
                                value: "＜4.5",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "＜10",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜350",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "＜300",
                                name: "Содержание железа(%)"
                            },
                            {
                                value: "＜200",
                                name: "Содержание кремния(%)"
                            },
                        ]
                    }
                ],
                foreignParameterRow: [{
                        title: "Ближн Восток",
                        pic: require("../../assets/img/mainBusiness/zhongdong.png"),
                        lists: [{
                                value: "＜3.3",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "＜10",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜200",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "＜200",
                                name: "Содержание железа(%)"
                            },
                            {
                                value: "＜100",
                                name: "Содержание кремния(%)"
                            },
                        ]
                    },
                    {
                        title: "индонез",
                        pic: require("../../assets/img/mainBusiness/yingni.png"),
                        lists: [{
                                value: "＜0.50",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "＜14.5",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜10",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "＜120",
                                name: "Содержание железа(%)"
                            },
                            {
                                value: "＜150",
                                name: "Содержание кремния(%)"
                            },
                        ]
                    },
                    {
                        title: "американск",
                        pic: require("../../assets/img/mainBusiness/meiguo.png"),
                        lists: [{
                                value: "＜4.5",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "＜12",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜450",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "＜150",
                                name: "Содержание железа(%)"
                            },
                            {
                                value: "＜180",
                                name: "Содержание кремния(%)"
                            },
                        ]
                    },
                    {
                        title: "европ",
                        pic: require("../../assets/img/mainBusiness/ouzhou.png"),
                        lists: [{
                                value: "＜1.5",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "＜10",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜200",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "＜150",
                                name: "Содержание железа(%)"
                            },
                            {
                                value: "＜150",
                                name: "Содержание кремния(%)"
                            },
                        ]
                    },
                    {
                        title: "Южн америк",
                        pic: require("../../assets/img/mainBusiness/nanmei.png"),
                        lists: [{
                                value: "＜0.7",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "＜10",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜180",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "＜80",
                                name: "Содержание железа(%)"
                            },
                            {
                                value: "＜80",
                                name: "Содержание кремния(%)"
                            },
                        ]
                    },
                    {
                        title: "СНГ",
                        pic: require("../../assets/img/mainBusiness/dulianti.png"),
                        lists: [{
                                value: "＜1.8",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "＜10",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜200",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "＜150",
                                name: "Содержание железа(%)"
                            },
                            {
                                value: "＜150",
                                name: "Содержание кремния(%)"
                            },
                        ]
                    }
                ],
            },
            petroleumBases: {
                headline2: {
                    title: "Четыре ключевые базы нефтяного кокса в Китае",
                    enTitle: "Four major domestic petroleum coke bases"
                },
                lists: [{
                        pic: require("../../assets/img/mainBusiness/db.png"),
                        title: "База в Северо-Восточном Китае",
                        des: "В полной мере используются преимущества ресурсов Северо-Восточного Китая, оптимизируем и консолидируем план строительства и размещения складской и смешанной логистической базы, а также выполняем дифференцированные операции."
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/hd.png"),
                        title: "База в Восточном Китае",
                        des: "Персонал базы внедряет двойную профессиональную и локализованную модель управления для улучшения обслуживания и повышения уровня профессионального менеджмента."
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/hn.png"),
                        title: "База в Южном Китае",
                        des: "Основываясь на преимуществах южнокитайского рынка и промышленной планировки, способствуем расширению производства нефтяного кокса в последующих производственных цепочках и расширяем возможности комплексного ведения бизнеса."
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/xb.png"),
                        title: "База в Северо-Западном Китае",
                        des: "Совершенствуем механизм интеграции управления закупками, продажами и логистикой, а также повышаем способность к активному сотрудничеству и быстрому реагированию на изменения рынка."
                    }
                ]
            },
            storageBase: {
                headline2: {
                    title: "Складская база",
                    enTitle: "Storage base"
                },
                des: `Компания в основном сотрудничает с нефтеперерабатывающими заводами, принадлежащими Sinopec, Petro China, CNPC, нефтеперерабатывающими заводами в провинции Шаньдун, на Северо-востоке, Северо-западе, в провинции Хэнань, Хэбэй, Цзянсу и других местах, крупными иностранными нефтехимическими компаниями и трейдерами, а также установила долгосрочные стратегические партнерские отношения с крупными отечественными и зарубежными алюминиевыми заводами, сталелитейными заводами, заводами по производству металлического кремния. заводы, предприятия по производству стекла и т.д.`
            },
            recommend: {
                headline2: {
                    title: "Похожие материалы",
                    enTitle: "Relevant recommendation"
                }
            }
        },
        cpc: {
            header: {
                typeTitle: "Основной продукт",
                title: "Прокаленный кокс",
                enTitle: "CPC",
                des: `В 2018 году наша компания открыла завод по переработке кальцинированного кокса в Хулудао, провинция Ляонин. Мощность введенного в эксплуатацию завода может достигать 200 000 тонн кальцинированного кокса и 6000 тонн в месяц с низким содержанием серы для производства графитированных электродов. В компании работают специалисты по переработке обожженного кокса и профессиональная техническая команда, в основном для компании Jinxi Daqing Fushun, которая занимается производством прокаливания и сортировки нефтяного кокса, которые могут быть настроены в соответствии с потребностями клиентов, а качество предоставляемых услуг по переработке гарантировано. С точки зрения качества и цены продукции, логистики и складского контроля продукции, а также быстрого расчета, мы можем оптимизировать план закупок для наших клиентов, чтобы гарантировать высокое качество продукции, разумную цену и своевременную доставку. Сократите расходы для наших клиентов, обеспечьте качественный сервис и увеличьте ценность.`,
            },
            parameters: {
                titleM: "С средним содержанием серы",
                parameterM: [{
                        pic: require("../../assets/img/mainBusiness/zbh.png"),
                        name: "Стандартные нормы",
                        lists: [{
                                value: "≤3",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "≤1.5",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "≤500",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "≥2.05",
                                name: "Истинная плотность(%)"
                            },
                            {
                                value: "≤0.5",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜500",
                                name: "Удельное сопротивление(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/puhuo.png"),
                        name: "Товары общего назначения",
                        lists: [{
                                value: "≤3.5",
                                name: "Содержание серы(%)"
                            },
                            {
                                value: "≤1.5",
                                name: "Выход летучих веществ(%)"
                            },
                            {
                                value: "≥600",
                                name: "Содержание ванадия(%)"
                            },
                            {
                                value: "≥2.05",
                                name: "Истинная плотность(%)"
                            },
                            {
                                value: "≤0.5",
                                name: "Золная характеристика(%)"
                            },
                            {
                                value: "＜550",
                                name: "Удельное сопротивление(%)"
                            },
                        ]
                    },
                ],
                titleL: "С низким содержанием серы",
                parameterL: [{
                    pic: require("../../assets/img/mainBusiness/fsgc.png"),
                    name: "фабрика в Фушуне",
                    lists: [{
                            value: "≤0.5",
                            name: "Содержание серы(%)"
                        },
                        {
                            value: "≤0.5",
                            name: "Выход летучих веществ(%)"
                        },
                        {
                            value: "0.5",
                            name: "Содержание  влаги(%)"
                        },
                        {
                            value: "≥2.08",
                            name: "Истинная плотность(%)"
                        },
                        {
                            value: "≤0.5",
                            name: "Золная характеристика(%)"
                        },
                        {
                            value: "350~450",
                            name: "Удельное сопротивление(%)"
                        },
                    ],
                    url: '/besinessScope/productionManufacturing'
                }, ],
            },
            recommend: {
                headline2: {
                    title: "Похожие материалы",
                    enTitle: "Relevant recommendation"
                }
            }
        }
    },
    bulkTrade: {
        banner: {
            bannerTitle: "Оптовая торговля",
            bannerP: "Bulk Trade",
        },
        headlineTitle: "Oптовая торговля",
        headlineP: "BULK TRADE",
        mainBusiness: 'Главн казарм',

    },
    bulkTradeDetail: {
        home: "Главная страница",
        lists: "оптовая торговля",
        share: "подел",
        copyAddress: 'Копировать адрес',
        productIntroduction: "профиль компании",
        factoryIntroduction: 'Рабочая площадка/фронт работы',
        relevantRecommendation: 'Похожие материалы'
    },
    integratedLogistics: {
        banner: {
            bannerTitle: "Интегрированная логистика",
            bannerP: "Integrated logistics",
        },
        logisticsService: {
            headlineTitle: "Логистические услуги",
            headlineP: "LOGISTICS SERVICE",
            lists: [{
                    title: "Автомобильный транспорт",
                    des: `Основываясь на многолетнем операционном накоплении, компания объединяет 8000 + кооперативные транспортные ресурсы, диапазон перевозки покрывает крупные партии массовых грузов, инженерных транспортных средств, запасных частей, опасных грузов и других грузов. Основываясь на богатом опыте управления пропускной способностью, ориентируясь на качественный опыт обслуживания клиентов, предоставлять клиентам услуги автомобильного транспорта по всей стране и России.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service1.png")
                },
                {
                    title: "Железнодорожные перевозки",
                    des: `В железнодорожном обслуживании есть высококвалифицированная, опытная в эксплуатации профессиональная команда, специализирующаяся на организации крупногабаритных грузов, инженерного оборудования, крупногабаритных грузовых перевозок, может эффективно справляться со всеми видами сложных транспортных потребностей, бизнес охватывает все регионы страны, а также пять стран и регионов России, Центральной Азии и других стран, сопровождение отправки грузов клиентов.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service2.png")
                },
                {
                    title: "Морские перевозки",
                    des: "Опираясь на долгосрочное стабильное сотрудничество с судоходными компаниями и портами, в соответствии с требованиями клиентов, разработать полный план транспортировки, предоставить фрахтование, сбор, контроль, отслеживание грузов и другие всесторонние и совершенные услуги по перевозке навалочных грузов в одном месте.",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service3.png")
                },
                {
                    title: "Мультимодальные перевозки",
                    des: `Ориентируемся на потребности клиентов, интегрируем различные ресурсы, такие как автомобильные, железнодорожные и водные пути, чтобы предоставлять клиентам мультимодальные транспортные решения "от двери до двери", в полной мере используем преимущества и совокупную эффективность различных видов транспорта, а также оптимизируем транспортные связи для клиентов. Сокращяем расходы на перевозку и получаем дополнительные экономические выгоды.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service4.png")
                },
                {
                    title: "Трансграничная логистик",
                    des: `В ответ на призыв национальной инициативы “Один пояс, один путь” ускоряем интернационализацию бизнеса, удовлетворяем различные потребности клиентов, предоставляем комплексные услуги по международным перевозкам, таможенному оформлению за рубежом и трансграничным расчетам в юанях, устраняем болевые точки в многонациональной цепочке поставок и берем на себя крупные обязательства по масштабированию долгосрочного ассоциативного бизнеса.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service5.png")
                },
                {
                    title: "Перевозка сжиженного газа танкерами",
                    des: `Компания имеет профессиональную команду управления транспортом, знакома с физико - химическими свойствами LPG и стандартами безопасной перевозки опасных грузов, предоставляет клиентам индивидуальное транспортное решение LPG, транспортные средства оснащены спутниковой системой позиционирования GPS и системой аварийного торможения, для достижения полного визуального мониторинга и быстрого реагирования, обеспечения безопасности транспортировки во всех аспектах.`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service6.png")
                },
            ]
        },
        loremIpsumDolorSit: {
            headlineTitle: "Обработка на складе",
            headlineP: "LOREM IPSUM DOLOR SIT",
            des: "Компания создала стратегические базы по импорту и экспорту в важных внутренних портах, таких как: Паньцзинь, Жичжао, Вэйфан, Ляньюньган, Фанчэн, Циньчжоу, а также в России и Южной Корее; она создала грузовые склады и базы по переработке в Синьцзяне, Цинхае, Ганьсу, Нинся, Шаньдуне, Хэнани, Чунцине, Ляонине и других городах. другие внутренние провинции и города.",
            map: require('../../assets/img/businessScope/integratedLogistics/map-ru.png'),
            lists: [{
                    title: "Логистическая обработка",
                    des: "В зависимости от характера товаров и потребностей клиентов, для удовлетворения разнообразных потребностей клиентов могут быть предоставлены дополнительные услуги, такие как сортировка, смешивание и фасовка.",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/wljg.png"),
                    icon: require("../../assets/img/businessScope/integratedLogistics/wljg_icon.png"),
                },
                {
                    title: "Услуги агентирования по закупкам",
                    des: "Компания создала платформу для выставки и закупок сыпучих продуктов и товаров, таких как нефтяное оборудование, строительная техника, запчасти для автомобилей, электронные продукты и руды, в сочетании с транспортными услугами «от двери до двери», чтобы предоставить клиентам полный спектр услуг агентства по закупкам.",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/cgdl.png"),
                    icon: require("../../assets/img/businessScope/integratedLogistics/cgdl_icon.png"),
                },
            ]
        },
        networkFreight: {
            headlineTitle: "Сетевые грузоперевозки",
            headlineP: "NETWORK FREIGHT",
            picUrl: require("../../assets/img/businessScope/integratedLogistics/wlhy-ru.jpg"),
            lists: [{
                    title: "Платформа Хао Юнда",
                    des: "Торговая платформа для групповых логистических услуг, созданная собственными силами, управление процессами, электронная бухгалтерская отчетность, стыковка и координация систем поддержки, а также предоставление универсальных транспортных услуг.",
                    icon: require("../../assets/img/businessScope/integratedLogistics/network1.png"),
                },
                {
                    title: "Возможности корпорации",
                    des: "У компании есть собственная команда по исследованиям и разработкам, которая помогает предприятиям в продвижении цифровой трансформации, сокращении затрат и повышении эффективности информатизации предприятий.",
                    icon: require("../../assets/img/businessScope/integratedLogistics/network2.png"),
                },
                {
                    title: "Дополнительные услуги",
                    des: "Взяв за основу бизнес по перевозке сыпучих грузов наземным транспортом, мы построили экологическую производственную цепочку, состоящую из грузоотправителей, водителей, платформ, страхования, финансов и сервисного обслуживания транспортных средств.",
                    icon: require("../../assets/img/businessScope/integratedLogistics/network3.png"),
                },

            ]
        },
        projectCase: {
            headlineTitle: "Пример проекта",
            headlineP: "PROJECT CASE",
            lists: [{
                    title: "Проект строительства трансграничной автомагистрали на инженерном транспорте",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case1.png"),
                },
                {
                    title: "Автомобильные перевозки товаров с ограниченным доступом",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case2.png"),
                },
                {
                    title: "Контейнерные перевозки алюминиевых изделий в сборном виде",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case3.png"),
                },
                {
                    title: "Железнодорожные перевозки Китай-ЕС железнодорожным транспортом",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case4.png"),
                },
                {
                    title: "Проект по контейнеризации транспортных средств и аксессуаров",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case5.png"),
                },
                {
                    title: "Проект по перевозке товаров",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case6.png"),
                },
            ]
        }
    },
    productionManufacturing: {
        banner: {
            bannerTitle: "Производство",
            bannerP: "Production Manufacturing",
        },
        table: {
            fushun: "Завод Лунтэн в Фушуне",
            lv: "Завод по переработке алюминиевых изделий"
        },
        FS: {
            factory: {
                headlineTitle: "Завод Лунтэн в Фушуне",
                headlineP: "FUSHUN LONGTENG FACTORY",
                des: "Международная промышленно-торговая группа Дацин Гаосинь в апреле 2022 года основала дочернюю компанию Fushun Longteng New Materials Co., Ltd., находящуюся в полной собственности. В основном она занимается исследованиями и разработкой, производством и продажей новых материалов и продуктов в области новых энергетических технологий. Это ключевое предприятие, привлекающее инвестиции в провинции Ляонин, и ведущее системообразующее предприятие в новой энергетической отрасли города Фушунь.",
                factoryBox: {
                    title: "FUSHUN LONGTENG FACTORY",
                    smallTitle: "Завод Лунтэн в Фушуне",
                    des: "Проект расположен в Фушуньской зоне развития высокотехнологичной промышленности, занимает площадь около 192 акров, общий объем инвестиций в проектирование составляет 1,71 млрд. юаней, в основном производство литиевых батарей искусственных графитовых отрицательных материалов, углерода и других новых материалов, новых энергетических продуктов и связанных с ними технологий исследований и разработок и продаж, продукция хорошо продается по всей стране и экспортируется во многие страны и регионы.",
                    link: 'Fushun Longteng Factory：https://www.fsltxcl.cn/'
                }
            },
            manufacturingStrength: {
                headlineTitle: "Власть.",
                headlineP: "MANUFACTURING STRENGTH",
                lists: [{
                        title: "Линия по производству катодов",
                        des: `Отрицательная производственная линия цеха интегрирует многоканальные процессы, такие как дробление, сушка и измельчение отрицательного материала, благодаря высокоавтоматизированному оборудованию и процессам для достижения эффективной трансформации от сырья к готовой продукции.`,
                        des2: `Годовая мощность: линия сушки 150 000 тонн, линия измельчения 100 000 тонн.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/zzsl1.png")
                    },
                    {
                        title: "Производственная линия цеха обжига",
                        des: `Обжигательный цех состоит в основном из установки предварительной обработки сырья, установки обжиговой печи, установки охлаждающей воды, установки десульфурационной башни, котельной установки остаточного тепла и других устройств.`,
                        des2: `Годовая мощность: линия прокаливания 60000 тонн.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/zzsl2.png")
                    },
                    {
                        title: "Производственная линия цеха гранулирования",
                        des: `Фармацевтический цех является производственным районом, специализирующимся на производстве гранул из новых энергетических материалов, и его продукция широко используется во многих областях новой энергетической промышленности.`,
                        des2: `Планирование, строительство и ввод в эксплуатацию производственных линий с годовой производительностью 80 000 тонн грануляции и предварительного карбонизации.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/zzsl3.png")
                    },
                ]
            },
            mainProduct: {
                headlineTitle: "Основной продукт",
                headlineP: "MAIN PRODUCT",
                lists: [{
                        title: "Прокаленный кокс с низким содержанием серы",
                        des: `Для производства отбирается высококачественный нефтяной кокс с низким содержанием серы, который после дробления и обжига может быть использован в качестве катода литиевой батареи и высококачественного сырья для графитовых электродов. Продукция используется в производстве катодов для литиевых батарей и угольных графитовых электродов большой и сверхмощной мощности и может быть настроена в соответствии с потребностями заказчика.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main1.png")
                    },
                    {
                        title: "Материал для дробления катодов литиевых батарей",
                        des: `Материал для дробления катодов литиевых батарей производится из высококачественного нефтяного кокса, игольчатого кокса или кальцинированного кокса при производстве катодов для литиевых батарей, также продукт может быть адаптирован в соответствии с потребностями заказчика.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main2.png")
                    },
                    {
                        title: "Кальцинированный кокс - искусственный графитовый анодный материал",
                        des: `Высококачественное сырье отбирается и обрабатывается с помощью нескольких процессов. Продукт обладает небольшим расширением, хорошей производительностью, высокой емкостью и отличным соотношением цены и качества. Он подходит для хранения энергии и аккумуляторов 3C большой емкости.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main3.png")
                    },
                    {
                        title: "Анодный материал из искусственного графита",
                        des: `Высококачественное сырье отбирается и тщательно обрабатывается с помощью различных процессов термообработки, таких как гранулирование и предварительная карбонизация. Отличные характеристики высокотемпературного цикла и увеличения, хорошая производительность и эффективность обработки, подходит для электромобилей и других электрических продуктов.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main4.png")
                    },
                    {
                        title: "Игольчатый кокс искусственный графитовый анодный материал",
                        des: `При использовании высококачественного игольчатого кокса в качестве сырья, после дробления, гранулирования, графитизации и последующей обработки, продукт обладает хорошей производительностью, цикличностью и коэффициентом увеличения и подходит для использования в различных областях применения высококачественных отрицательных электродов.`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main5.png")
                    },
                ]
            },
            qualityAssurance: {
                headlineTitle: "Гарантии качества",
                headlineP: "QUALITY ASSURANCE",
                lists: [{
                        title: "Лазерный анализатор размера частиц Baite",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/baitejiguan.jpg")
                    },
                    {
                        title: "Испытатель сопротивления порошка",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/fengmodianzu.jpg")
                    },
                    {
                        title: "Спектрометр",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/guangpuyi.jpg")
                    },
                    {
                        title: "Лазерный анализатор размера частиц Malvern",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/jiguangliduyi.jpg")
                    },
                    {
                        title: "Истинный измеритель плотности",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/zhengmiduyi.jpg")
                    },
                    {
                        title: "Вибрационный измеритель плотности",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/zhengshimiduyi.jpg")
                    },

                ]
            },
            honorAndAualification: {
                headlineTitle: "Технические патенты",
                headlineP: "TECHNICAL PATENTS",
                list: [
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/1.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/2.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/3.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/4.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/5.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/6.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/7.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/8.jpg") },
                ]
            },
            schoolEnterpriseCooperation: {
                headlineTitle: "Сотрудничество с институтами и предприятиеми",
                headlineP: "SCHOOL-ENTERPRISE COOPERATION",
                des: "<p>В то же время он наладил сотрудничество “промышленность-университет-исследовательская школа-предприятие” с Ляонинским университетом нефти и химических технологий, Северо-Восточным университетом и многими другими колледжами и университетами.</p>",
                tip: "и другие учереждения в процессе обновления..."
            },
        },
        AL: {
            factory: {
                headlineTitle: "Завод по переработке алюминиевых изделий",
                headlineP: "ALUMINIUM PRODUCT PROCESSING PLANT",
                des: `Завод по переработке алюминиевых изделий является дочерним предприятием, полностью принадлежащим Международной промышленно-торговой группе Daqing High-tech. Это завод, который производит различные виды алюминиевых рулонов и алюминиевых листов. Компания предоставляет продукцию и услуги для широкого спектра отраслей промышленности, включая аэрокосмическую, автомобильную, жилищно-строительную, транспортную, упаковочную и для товаров повседневного спроса.`,
                factoryBox: {
                    title: "ALUMINIUM PRODUCT PROCESSING PLANT",
                    smallTitle: "Завод по переработке алюминиевых изделий",
                    des: `Компания может производить и продавать все виды алюминиевых рулонов, алюминиевой фольги и алюминиевых пластин. Она может широко использоваться в производстве мебели, посуды и других областях. Продукция экспортируется более чем в 30 стран, таких как Россия, Бразилия, Мексика, Объединенные Арабские Эмираты, Вьетнам, Таиланд и Филиппины.`
                }
            },
            manufacturingStrength: {
                headlineTitle: "Качественный обслуживание",
                headlineP: "MANUFACTURING STRENGTH",
                lists: [{
                        title: "Изготовление продукции на заказ",
                        des: "Покажите нам образцы или чертежи, и мы предложим вам идеальный продукт.",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service1.png")
                    },
                    {
                        title: "Стоимость и услуги",
                        des: "Объединяя производство и продажи, мы располагаем цехами прокатки и глубокой переработки, а также профессиональной командой внешнеторговых специалистов.Вы можете воспользоваться не только ценой производителя, но и профессиональными внешнеторговыми услугами.",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service2.png")
                    },
                    {
                        title: "Скорость ответа",
                        des: "На ваши электронные письма, запросы и вопросы мы ответим в течение 2 часов. Завершите все работы в короткие сроки, и образцы и оптовые заказы будут доставлены в срок с соблюдением высоких стандартов.",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service3.png")
                    },
                    {
                        title: "Качество продукции",
                        des: "Строгая система контроля качества и современное контрольно-измерительное оборудование.",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service4.png")
                    },
                ]
            },
            mainProduct: {
                headlineTitle: "Основной продукт",
                headlineP: "MAIN PRODUCT",
                lists: [{
                        title: "Алюминиевый лист",
                        des: "<p>Диапазон толщины: 0,2-20 мм</p><p>Диапазон ширины: 50-2200 мм</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvban.png")
                    },
                    {
                        title: "Алюминиевый рулон",
                        des: "<p>Диапазон толщины: 0.2-5мм</p><p>Диапазон ширины: 50-1600мм</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvjuan.png")
                    },
                    {
                        title: "Алюминиевый диск",
                        des: "<p>Диапазон толщины: 0.5-5мм</p><p>Диапазон ширины: 150-1500мм</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvyuanpian.png")
                    },
                    {
                        title: "Фольга",
                        des: "<p>Диапазон толщины: 0.01-0.2мм</p><p>Диапазон ширины: 50-2200мм</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvbo.png")
                    },
                    {
                        title: "Алюминиевый стержень",
                        des: "<p>Диапазон толщины: 1-3000мм</p><p>Диапазон ширины: 50-2200мм</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvbang.png")
                    },
                    {
                        title: "Алюминиевый слитокv",
                        des: "<p>Диапазон толщины: 760*185*90мм</p><p>Вес: около 20 — 25 кг</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvding.png")
                    },
                ]
            },
            qualityAssurance: {
                headlineTitle: "Гарантии качества",
                headlineP: "QUALITY ASSURANCE",
                lists: [{
                        title: "Оборудование для коррекции изгиба",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz1.png")
                    },
                    {
                        title: "Валок стана горячей прокатки",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz2.png")
                    },
                    {
                        title: "Установка стана горячей прокатки",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz3.png")
                    },
                    {
                        title: "Складские запасы",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz4.png")
                    },

                ]
            },
        },

    },
    industryFinanceCollaboration: {
        banner: {
            bannerTitle: "координация промышленности и финансов",
            bannerP: "Industry Finance Collaboration",
        },
        globalLayout: {
            headlineTitle: "Глобальная планировка",
            headlineP: "LOREM IPSUM DOLOR SIT",
            des: `Международная промышленно-торговая группа Daqing Gaoxin была основана в 2007 году и за это время открыла офисы в Южной Корее, Японии, России, Индонезии, Дубае и многих других странах. После многих лет тщательного изучения и развития международный бизнес компании в настоящее время охватывает шесть основных областей: энергетическое и химическое сырье и продукты из него, машины и оборудование, а также промышленное оборудование, новые энергетические материалы и продукты для производства литиевых аккумуляторов, минеральные металлы, агрохимикаты и экспорт подержанных автомобилей.`,
            map: require("../../assets/img/businessScope/industryFinanceCollaboration/map.png"),
        },
        generationMiningAndGenerationPin: {
            headlineTitle: "Деше и его замена",
            headlineP: "GENERATION MINING AND GENERATION PIN",
            enterpriseAdvantage: {
                title: "Корпоративное преимущество",
                titleEn: "ENTERPRISE ADVANTAGE",
                des: "<p>Китайский/трансграничный</p><p>Импорт (от имени горнодобывающей промышленности)</p><p>Экспорт (консигнация)</p>",
                btn: "Свяжись с нами."
            },
            lists: [{
                    title: "Морские перевозки",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/haiyun.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/haiyun.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/haiyun.png"),
                },
                {
                    title: "словоохотлив",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/huodai.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/huodai.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/huodai.png"),
                },
                {
                    title: "Порт расчета с экспедитором",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/jiesuan.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/jiesuan.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/jiesuan.png"),
                },
                {
                    title: "порт",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/gangkou.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/gangkou.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/gangkou.png"),
                },
                {
                    title: "ЖД Поезд",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/banlie.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/banlie.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/banlie.png"),
                },
                {
                    title: "Оффшорный склад.",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/haiwaicang.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/haiwaicang.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/haiwaicang.png"),
                },
                {
                    title: "Инспекция зарубежных складов",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/jianyan.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/jianyan.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/jianyan.png"),
                },
                {
                    title: "Таможенная декларация",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/baoguan.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/baoguan.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/baoguan.png"),
                },
            ]
        },
        protectionAndFactoring: {
            headlineTitle: "Гарантия и факторинг",
            headlineP: "PROTECTION AND FACTORING",
            des1: `В 2023 году Международная промышленно-торговая группа Daqing Gaoxin была удостоена звания “Клиент Китайской компании по страхованию экспортных кредитов” уровня AAA (далее - "Китайское кредитное страхование"). Это первое частное предприятие в провинции Хэйлунцзян, получившее эту награду.，
            В то же время это также первое частное предприятие в провинции Хэйлунцзян, получившее разрешение на страхование кредитов от внутренней торговли в Китае.`,
            des2: `Компания предоставляет комплексные услуги по закупкам, транспортировке и продажам по всей цепочке поставок на протяжении всего процесса, чтобы обеспечить бесперебойный поток международных товаров, информационных фондов и счетов, а также обеспечить предоставление экономически эффективных товаров в соответствии с требованиями заказчика.Компания располагает профессиональными каналами закупок и продаж сыпучих товаров, таких как нефтяное оборудование, инженерное оборудование, аксессуары для автомобилей, электронные изделия и руда. В сочетании с услугами по доставке "от двери до двери", она может предоставить клиентам универсальную платформу для закупок и продаж.`
        },
        industrialInvestment: {
            headlineTitle: "Инвестиции в промышленность",
            headlineP: "INDUSTRIAL INVESTMENT",
            des: `Компания будет продолжать придерживаться рыночных, клиентоориентированных и инновационных принципов и создавать большую ценность для инвесторов, партнеров и общества.`,
            lists: [{
                    title: "Бизнес по производству литиевых батарей",
                    des: `Инвестиции компании направлены на основной бизнес - торговлю нефтяным коксом и производство анодных материалов для литиевых батарей (производство анодных материалов для литиевых батарей, переработка литиевых батарей), а также на интеграцию слияний и поглощений в области добычи и переработки энергии для повышения синергии и конкурентоспособности производственной цепочки, формируя система полного энергетического цикла.`,
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/lidian.png"),
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/lidian_icon.png"),
                },
                {
                    title: "Бизнес в области водородной энергетики",
                    des: `Компания также уделяет внимание изучению инвестиционных возможностей в области новой энергетики. Она сотрудничает с известными научно-исследовательскими институтами и университетами в стране и за рубежом для проведения исследований и экспериментов по технологии производства водородной энергии и добилась ряда прорывов и инноваций. В ближайшие несколько лет компания планирует приобрести компании по производству оборудования для производства водородной энергии, обладающие независимыми правами интеллектуальной собственности, чтобы внести свой вклад в преобразование энергетики и развитие низкоуглеродной энергетики.`,
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/qingnengyuan.png"),
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/qingnengyuan_icon.png"),
                },
            ]

        }
    },
    exportOfServices: {
        banner: {
            bannerTitle: "Кадровое обеспечение",
            bannerP: "Export of services",
        },
        headlineTitle: "Кадровое обеспечение",
        headlineP: "EXPORT OF SERVICES",
        des1: `Международная промышленно-торговая группа Daqing Gaoxin стремится предоставлять комплексные кадровые услуги предприятиям по всему миру, выстраивать надежную систему гарантированного обслуживания персонала и создавать высокодинамичную, гибкую и устойчивую цепочку поставок талантов.`,
        enterpriseAdvantage: {
            title: "Корпоративное преимущество",
            titleEn: "ENTERPRISE ADVANTAGE",
            des: `Опираясь на практический опыт, накопленный за последние 20 лет, углубленные исследования по анализу внутреннего и внешнего спроса на человеческие ресурсы и их предложения на предприятии, в сочетании с текущей ситуацией и стратегическими потребностями управления человеческими ресурсами предприятия, проектируем и планируем всю систему управления человеческими ресурсами и структуру предприятия. В то же время, учитывая наступление цифровой эры, отдел планирования людских ресурсов Daqing High-tech сосредоточит свое внимание на изучении возможностей повышения качества услуг в области цифровых трудовых ресурсов и информационных технологий, а также на предоставлении всесторонних услуг и поддержки крупным предприятиям по трудоустройству.`
        },
        des2: `В настоящее время компания обслуживает более 20 отечественных и зарубежных предприятий, предоставляя восемь категорий усовершенствованных и комплексных комплексных услуг, таких как планирование человеческих ресурсов, расчет заработной платы, механизм стимулирования, организационное планирование, система процессов, система трудоустройства и обучение талантов. Был создан профессиональный и высококвалифицированный кадровый резерв, включающий более десяти различных отраслей, таких как нефтехимия, электротехническое приборостроение, машиностроение, полупроводники, литиевые батареи нового поколения, оптовая торговля, комплексные функции, технический персонал и логистическая поддержка.`,
        lists: [{
                title: "20+",
                des: "Обслуживает более 20 отечественных и зарубежных кооперативных предприятий"
            },
            {
                title: "8+",
                des: "Восемь категорий усовершенствованного комплексного обслуживания для всех сторон"
            },
            {
                title: "15+",
                des: "Охватывает более десяти различных отраслей промышленности"
            },
        ]

    },
    news: {
        banner: {
            bannerTitle: "Новости.",
            bannerP: "News Information",
        },
        latestNews: {
            headlineTitle: "Последние новости",
            headlineP: "LATEST NEWS",
        },
        mediaReport: {
            headlineTitle: "сообщения в СМИ",
            headlineP: "MEDIA REPORT",
        },
        enterprisePublicity: {
            headlineTitle: "Корпоративная реклама",
            headlineP: "ENTERPRISE PUBLICITY",
        },
        parameter: {
            read: "Читать далее"
        }
    },
    newsDetail: {
        home: "Главная страница",
        lists: "Новости.",
        time: "врем：",
        edit: "редактор：DQ CARBON GROUP",
        share: "подел",
        pre: "Последняя.：",
        next: "Дальше.："
    },
    socialResponsibility: {
        banner: {
            bannerTitle: "Социальная ответственность",
            bannerP: "Social Responsibility",
        },
        environmentalProtection: {
            headlineTitle: "Защита окружающей среды",
            headlineP: "ENVIRONMENTAL PROTECTION",
            des: {
                text1: `Компания глубоко придерживается концепции зеленого развития, продолжает уделять внимание охране окружающей среды, использованию возобновляемых источников энергии, энергосбережению и сокращению выбросов, а также вторичной переработке ресурсов на предприятиях и в цепочках поставок, выступает за “зеленую экономику замкнутого цикла”, способствует энергосбережению и сокращению выбросов и предпринимает практические действия для выполнения экологических обязательств и поможет достичь цели “двойного выброса углерода”.`,
                text2: `Завод компании в Фушуне спланирован в соответствии с нормами местного правительства, не подлежащими ликвидации в течение 15 лет, и использует передовые немецкие технологии по защите окружающей среды с ультранизким уровнем выбросов,что позволяет повторно использовать все отходы производства, а также не допускать сброса остатков промышленных отходов, сточных вод и макулатуры. на протяжении всего процесса.`
            }
        },
        scienceAndTechnologyInnovate: {
            headlineTitle: "научно-технические инновации",
            headlineP: "SCIENCE AND TECHNOLOGY INNOVATE",
            des: {
                text1: `Международная промышленно-торговая группа Дацин Гаосинь создала научно-исследовательские базы в Фушуне, Харбине и многих других местах, усилила подготовку научно-технического персонала и наняла международных и отечественных научно-исследовательских и технических экспертов, чтобы сосредоточиться на развитии производства высокочистого графита и применении новых технологий, новых процессов плавки и т.д., с целью постоянного продвижения научно-технических инноваций компании.`,
                text2: `Что касается производства и переработки, то на заводах компании реализована интеллектуальная, автоматизированная конвейерная транспортировка и замкнутое производство с момента поступления сырья на фабрику до выпуска готовой продукции. Сотрудники не участвуют в каких-либо операциях с оборудованием и должны только проводить инспекции на протяжении всего процесса.На заводе по борьбе с пожарами также реализована система автоматического пожаротушения с термоиндукцией и отслеживанием, позволяющая решить проблему угроз безопасности с точки зрения технологии оборудования.`
            }
        },
        socialGood: {
            headlineTitle: "социальное обеспечение",
            headlineP: "SOCIAL GOOD",
            des: {
                title: "Пожертвовал 1 миллион юаней и материалы Красному Кресту провинции Хэйлунцзян",
                text1: `В сентябре 2022 года борьба с новой коронавирусной эпидемией вступила в критический момент. Международная промышленно-торговая группа "Дацин Гаосинь" выступила с инициативой взять на себя корпоративную социальную ответственность и пожертвовала 1 миллион долларов Дацинскому Красному Кресту провинции Хэйлунцзян, чтобы практическими действиями поддержать профилактику эпидемии в Дацине и борьбу с ней.Это пожертвование используется для приобретения необходимых материалов для профилактики эпидемий и предоставления их нуждающимся для обеспечения их здоровья и безопасности.`,
                text2: `В августе 2023 года город Учан провинции Хэйлунцзян продолжал страдать от обильных осадков и сильного наводнения.После стихийного бедствия компания как можно скорее передала средства для оказания помощи в ликвидации последствий наводнения Красному кресту Учана, чтобы помочь жителям Учана преодолеть последствия наводнения и восстановить свои дома.`
            },
            des2: {
                title: "Передано более миллиона материалов по профилактике эпидемий посольствам Ирана и других стран",
                text1: `Тысячи миль - это одно и то же, судьба одна и та же!В июле 2020 года, в связи с трудным периодом профилактики эпидемий и борьбы с ними в стране и за рубежом, Международная промышленно-торговая группа Дацин Гаосинь и ее филиалы в стране и за рубежом передали дезинфицирующие средства, маски и другие материалы для профилактики эпидемий посольствам Ирана, России и других стран и объединили усилия с друзья со всего мира объединятся, чтобы победить эпидемию.`
            }

        }
    },
    talentDevelopment: {
        banner: {
            bannerTitle: "Развитие кадрового потенциала",
            bannerP: "Talent development",
        },
        growthAndDevelopment: {
            headlineTitle: "Рост и развитие",
            headlineP: "GROWTH AND DEVELOPMENT",
            des: `<p>Мы поддерживаем механизм трудоустройства, который позволяет нам подниматься и опускаться, подбирать должности, знать людей и эффективно использовать их, а также использовать таланты, чтобы дать способным сотрудникам возможность в полной мере проявить себя.</p>
            <p>“Делай то же самое, нравись тем же, стань таким же” - вот характерная черта новичков высокого уровня из Дацина.</p>
            <p>Здесь простые межличностные отношения, справедливый механизм продвижения по службе и широкие возможности для развития.</p>`,
            boxRow: {
                title: "Кадры являются первичной производительной силой.  DQ Carbon Group неизменно придерживается принципа ориентации на человека.",
                p: 'Компания защищает законные права и интересы сотрудников, создаёт широкие карьерные возможности и реализует программы профессионального обучения.'
            },
            boxRow2: {
                title: "Забота о жизни сотрудников и внимательное отношение к их благополучию, повышение чувства принадлежности к компании и осознания собственной ценности.",
                p: 'Повышение конкурентоспособности в отрасли с целью достижения общего роста и развития компании и сотрудников.'
            }
        },
        employeeCare: {
            headlineTitle: "Забота о сотрудниках",
            headlineP: "EMPLOYEE CARE",
            des: 'Компания придаёт большое значение развитию всесторонних компетенций сотрудников и совершенствованию их профессиональных навыков, формирует обучающуюся команду и способствует совместному росту сотрудников и компании, стремясь к достижению взаимного развития предприятия, общества и персонала.'
        },
        talentRecruitment: {
            headlineTitle: "Вакансии",
            headlineP: "TALENT RECRUITMENT",
            des: 'В эту стремительно меняющуюся эпоху мы ясно осознаём, что кадры являются самым ценным активом компании, и поэтому искренне приглашаем каждого, кто целоустремлен и готов к новым вызовам, присоединиться к нам.',
            part1: 'Вакансии',
            part2: 'Вакансии для частичной занятости',
            join: 'Присоединяйтесь к нам'
        },
    },
    talentRecruitment: {
        banner: {
            bannerTitle: "Вакансии",
            bannerP: "Talent Recruitment",
        },
        tabs: {
            society: 'Социальный подбор персонала',
            partTime: 'Hеполный рабочий день',
            postName: 'Вакансия по подбору персонала.',
            userNum: 'Количество сотрудников',
            workArea: 'Место работы',
            wages: 'Зарплата',
            createTime: 'Время опубликации',
            btn: 'Отправить резюме',
            mainWork: 'Описание должности',
            baseDemand: 'Требования к кандидату'
        },
        updataForm: {
            title: 'Загрузить резюме',
            updataBtn: 'загрузк',
            type: 'формат',
            submitBtn: 'Отправить'
        }
    },
    supervisionAndReporting: {
        banner: {
            bannerTitle: "Нарушения",
            bannerP: "Supervision and reporting",
        },
        introduce: `В целях укрепления построения чистого правительства, устранения незаконных и дисциплинарных нарушений, поддержания целостности трудового коллектива, воспитания у сотрудников благородной профессиональной этики, обеспечения добросовестности сотрудников при исполнении ими своих обязанностей и борьбы с поведением, наносящим ущерб интересам и имиджу компании, а также с сотрудниками, наносящими ущерб окружающей среде. добросовестное выполнение своих обязанностей в связи с коррупцией, получением коммерческих взяток и должностными преступлениями компания поощряет всех сотрудников, кооперативным подразделениям и всем слоям общества следует активно сообщать о мошенничестве и других нарушениях дисциплины и выплачивать высокие вознаграждения лицам, сообщающим о нарушениях, при этом строго защищая информаторов.`,
        reporting1: {
            headlineTitle: "Форма жалобы",
            headlineP: "REPORTING FORM",
            title1: "1. Содержание жалобы",
            title2: "2. Каналы информирования",
            des1: `<p>Компания призывает всех лиц, осведомленных в этом вопросе, сообщать или предоставлять эффективные доказательства следующих мошеннических действий:</p> 
            <p>1.Сотрудники получают взятки (например, подарки, премиальные, скидки за обслуживание, непродовольственные товары, туризм, развлекательные мероприятия высокого класса и т.д.) или другие выгоды (например, займы и мздоимство и т.д.), кражу, растрату или незаконное присвоение активов компании, мошенничество, разглашение секретов компании., злоупотребление полномочиями, ненадлежащие сделки со связанными сторонами, использование полномочий в личных целях и другие мошеннические действия.</p>
            <p>2. Взяточничество, воровство, растрата, мошенничество, разглашение коммерческой тайны и т.д. поставщиками или иностранными подразделениями, нарушения законов и нормативных актов или соглашений о добросовестности.</p>`,
            des2: `<p>Телефон для жалоб: 17813617807</p><p>Электронная почта для жалоб: gh_wang@gaoxincarbon.com</p>
            <p>Публичный аккаунт в WeChat: DQ CARBON GROUP</p><p>Другие способы: письмо, визит или любая другая форма</p>`
        },
        reporting2: {
            headlineTitle: "Вознаграждение за доклад",
            headlineP: "REPORTING REWARDS",
            title1: `1. За сообщение информации или предоставленные доказательства, если соответствующая информация может быть непосредственно принята судебными органами и дело квалифицируется как уголовное, выплачивается вознаграждение в соответствии со следующими стандартами:`,
            title2: `2. Тем, кто сообщает или предоставляет достоверную и непосредственно применимую информацию или доказательства и возмещает прямые экономические убытки компании (в зависимости от фактической суммы, полученной компанией, или суммы, определенной финансовым отделом), выплачивается вознаграждение в соответствии со следующими критериями:`,
            title3: `3. Вышеупомянутые вознаграждения могут быть наложены друг на друга и использованы после одобрения председателем правления.`,
            title4: `4. Для кооперативных подразделений, которые сообщают или предоставляют прямые и эффективные доказательства, также применяются вышеуказанные условия вознаграждения.`,
            des1: `
            <p>1. За дачу взятки негосударственным сотрудникам назначается вознаграждение в размере не менее 30 000 юаней;</p>
            <p>2. Если речь идет о других видах уголовных дел, таких как посягательство на служебное положение, кража и незаконное присвоение денежных средств, назначается вознаграждение в размере не менее 10 000 юаней.</p>
            `,
            des2: `<p>1. Если экономический ущерб составит менее 100 000 юаней (включая основную сумму), будет назначено вознаграждение в размере 1000 юаней; </p>
            <p>2. Если экономический ущерб будет возмещен в размере от 100 000 до 500 000 юаней (включая основную сумму), будет назначено вознаграждение в размере от 1000 до 5000 юаней.;</p>
            <p>3. Если экономический ущерб будет возмещен в размере от 500 000 юаней до 2 миллионов юаней (включая основную сумму), будет назначено вознаграждение в размере от 5000 юаней до 20 000 юаней.;</p>
            <p>4. Если экономический ущерб будет возмещен в размере от 2 до 8 миллионов юаней (включая основную сумму), будет назначено вознаграждение в размере от 20 000 до 80 000 юаней.;</p>
            <p>5. Если экономический ущерб превысит 8 миллионов юаней, будет назначено вознаграждение в размере 100 000 юаней.</p>`,
            btn: 'Онлайн-жалоба'
        },
        dialogForm: {
            title: 'Сообщить о нарушении',
            email: 'Электронная почта для жалоб',
            reporterType: 'Тип жалобы',
            reporterItems: 'Предмет жалобы',
            reportered: 'Субьект обжалования',
            reporteredTip: 'Имя  фамилия субьекта обжалования',
            deptName: 'Подразделение и отдел',
            reporter: 'Заявитель',
            reporterTip: 'Имя  фамилия информатора',
            ifShow: 'Анонимно',
            reporterMobile: 'Контактная информация информатора',
            file: 'Загрузка отчетных материалов',
            fileTip: 'Перетащить файл сюда или',
            fileBtn: 'Нажмите, чтобы загрузить',
            remark: 'Описание проблемы',
            remarkTip: 'Пожалуйста, опишите проблему',
            btn: 'Отправить',
            reporterItemsTip: 'Пожалуйста, выберите хотя бы одну жалобу',
            deptNameTip: 'Пожалуйста, заполните форму',
            reporterMobileTip: 'Пожалуйста, заполните контактную информацию информатора',
            uploadTip: 'Загрузка файла не должна превышать'
        }
    },
    contact: {
        banner: {
            bannerTitle: "Свяжись с нами.",
            bannerP: "Contact Us",
        },
        descLists: [{
                url: require("../../assets/img/contact/address.png"),
                title: 'Адрес штаб-квартиры:',
                desc: '13-й этаж, здание China Minmetals, № 15, Четвертый район Аньхуйли, район Чаоян, Пекин'
            },
            {
                url: require("../../assets/img/contact/phone.png"),
                title: 'Служебный телефон:',
                desc: '+86 10-84831159 Телефонный узел  &nbsp; &nbsp;  +86 10-84833454 Внутренняя торговля  &nbsp;&nbsp;  +86 10-84832433 Внешняя торговля <br/> По вопросам сотрудничества: +86 17813617961 &nbsp;&nbsp; Приёмная руководителя: +86 17813617885'
            },
            {
                url: require("../../assets/img/contact/email.png"),
                title: 'почтовый ящик:',
                desc: 'Gaoxin@gaoxincarbon.com'
            },
        ],
        wxName: 'Официальный аккаунт WeChat',
        dyName: 'Официальный аккаунт Tiktok',
        wdName: 'Микро-магазин'
    },
    year20: {
        // banner: {
        //     bannerTitle: "2020年",
        //     bannerP: "2020",
        // },
        vedio: {
            headling: 'Празднование 20 - летия компании DQ Carbon Group'
        },
        history: {
            headling: 'История развития'
        },
        news: {
            headling: '​Новостной репортаж к 20-летию компании DQ CARBON GROUP'
        },
        employee: {
            headling: '​Отличившиеся сотрудники к 20-летию DQ CARBON GROUP',
            des: `Десять лет точить меч, пятнадцать лет ковать славу, двадцать лет создавать легенду. В течение 20 - летнего развития компании была группа сотрудников, которые путешествовали вместе с компанией. Вместе они написали славные главы в истории компании своей молодостью и мечтой, преданностью и преданностью. Лучшие сотрудники со всей страны, которые служили десять, пятнадцать, двадцать лет, собрались вместе, чтобы получить благодарность от группы. Группа также приготовила для них специальный подарок — медаль за отвагу из чистого золота в знак благодарности за их выдающийся вклад. Представитель сотрудников "подвигов" вышел на сцену и выступил с трогательной речью, поделившись с компанией каждой деталью их роста.`,
            title15: 'Заслуженные сотрудники с 15-летним стажем',
            title10: 'Заслуженные сотрудники с 10-летним стажем',
            title20: 'Заслуженные сотрудники с 20-летним стажем'
        },
        bless: {
            headling: 'Сердечные поздравления DQ CARBON Group'
        },
        activity: {
            headling: 'Тематическое мероприятие к 20-летию компании DQ CARBON GROUP'
        },
    }

}

export default ru;